import { createApp } from 'vue';
import { createHead } from '@vueuse/head';
import { VueCookieNext } from 'vue-cookie-next';
import Vue3Storage from 'vue3-storage';
import App from './App.vue';
import router from './router';

import 'modern-normalize/modern-normalize.css';

createApp(App)
  .use(router)
  .use(createHead())
  .use(VueCookieNext)
  .use(Vue3Storage, { namespace: 'portfolio_' })
  .mount('#app');
